import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as result from "./style.module.scss";
export const Result = () => {
  return (
    <section className={`${result.result} ${main.sec}`} id="result">
      <div className="container">

        <h2 className={`${main.blockTitle} ${main.blockTitleMdM} ${result.result_title}`}>
          Благодаря курсу вы
        </h2>

        <div className={`row ${result.result_row}`}>
          <div className={`col col-3 ${result.result_col}`}>
            <div>
              <div className={result.result_colItem_header}>
                <div className={result.result_colItem_headerIcon}>
                  <img src="https://fs.advance.ru/landing-pages/online/smart/01-target.svg" alt="Цель"/>
                </div>
              </div>
              <div className={result.result_colItemName}>Научитесь</div>
              <div>ставить цели не&nbsp;только себе, но&nbsp;и&nbsp;подчиненным</div>
            </div>
          </div>

          <div className={`col col-3 ${result.result_col}`}>
            <div>
              <div className={result.result_colItem_header}>
                <div className={result.result_colItem_headerIcon}>
                  <img src="https://fs.advance.ru/landing-pages/online/smart/01-skills.svg" alt="Навыки"/>
                </div>
              </div>
              <div className={result.result_colItemName}>Сможете</div>
              <div>ставить цели так, <br/> чтобы&nbsp;они достигались</div>
            </div>
          </div>

          <div className={`col col-3 ${result.result_col}`}>
            <div>
              <div className={result.result_colItem_header}>
                <div className={result.result_colItem_headerIcon}>
                  <img src="https://fs.advance.ru/landing-pages/online/smart/01-presentation.svg" alt="Навыки"/>
                </div>
              </div>
              <div className={result.result_colItemName}>Примените</div>
              <div>полученные знания для&nbsp;достижения рабочих и&nbsp;личных целей</div>
            </div>
          </div>

          <div className={`col col-3 ${result.result_col}`}>
            <div>
              <div className={result.result_colItem_header}>
                <div className={`${result.result_colItem_headerIcon} ${result.result_colItem_headerIcon_special}`}>
                  <img src="https://fs.advance.ru/landing-pages/online/smart/01-businessman.svg" alt="Анализ"/>
                </div>
              </div>
              <div className={result.result_colItemName}>Выработаете</div>
              <div>привычку анализировать
                правильность постановки
                целей на&nbsp;базе четких
                критериев
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
